module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-2-img-pc@2x_c68beab0a6fb1d35cd95f405da053999.png";